/**
 * The word for a quote's status, in one place.
 *
 * `jobDetail.quoteStatus.*` was already the dictionary the requester's side of
 * the job page read (`JobDetail`, the badge on every quote card). The FixyBee's
 * own list did not read it — it printed `q.status` raw, so a Spanish reader got
 * "SENT" next to tabs that said "Enviadas". Two surfaces about the same five
 * values, one translated and one not.
 *
 * `QUOTE_STATUSES` is the same set the filter tabs are built from, so a status
 * added to the product cannot end up on the badge and miss the tabs.
 */

/** Every status a quote can be in, in the order the filter tabs show them. */
export const QUOTE_STATUSES = ["sent", "accepted", "declined", "withdrawn", "stale"];

/**
 * The statuses that leave a FixyBee free to send a new quote on the job — the
 * twin of `QUOTE_REPLACEABLE` in backend/db/enums.py. `stale` (T19) is a quote
 * the requester's edit made outdated: it cannot be accepted, and replacing it
 * costs nothing.
 */
export const QUOTE_REPLACEABLE = ["withdrawn", "stale"];

/** "Enviada" / "Sent". Falls back to the raw value for anything unmapped. */
export function quoteStatusLabel(t, status) {
  if (!status) return "";
  return t(`jobDetail.quoteStatus.${status}`, status);
}

/** The badge colour that goes with it, shared by the list and the detail. */
export function quoteStatusClass(status) {
  if (status === "accepted") return "bg-success text-cream";
  if (status === "declined") return "bg-danger text-cream";
  if (status === "sent") return "bg-hive text-worker";
  // Outdated asks for something — a new quote — so it reads as live, not as
  // the closed grey of declined and withdrawn.
  if (status === "stale") return "bg-info text-cream";
  return "";
}
